import { SET_DEPARTURE, UPDATE_SECTOR_LOADING, SET_TOURID, SET_TOURNAME, SET_PRICE, SET_PASSENGER, SET_ADVENTURE_DEPARTURE } from '../actions/types';
import update from 'immutability-helper';

const cartState = {
    "adventure_departure_date":"",
    "departure_date":"",
    "tour_id":"",
    "tour_name":"",
    "prices":"0.00",
    "update_sector_loading":false,
    "passengers":1
}

export function SetCart(state = cartState, action){
    switch(action.type){
        case SET_PASSENGER:
            return update(state, {passengers:{$set:action.payload}});    
        case SET_TOURID:
            return update(state, {tour_id:{$set:action.payload}});
        case SET_TOURNAME:
            return update(state, {tour_name:{$set:action.payload}});    
        case SET_PRICE:
            return update(state, {prices:{$set:action.payload}});
        case SET_DEPARTURE:
            return update(state, {departure_date:{$set:action.payload}});
        case UPDATE_SECTOR_LOADING:
            return update(state, {update_sector_loading:{$set:action.payload}});
        case SET_ADVENTURE_DEPARTURE:
            return update(state, {adventure_departure_date:{$set:action.payload}});        
        default:
            return state;
    }
}